import { Buffer } from 'buffer';
import { TestDataBuffer } from "@/types";

export const testDataOnStart: TestDataBuffer = {
    global: [],
    voice: {
      textMatrix: [],
      timestamps: [],
      activitiTimestamps: [],
      audio: Buffer.alloc(1)
    },
    writing: {
      behaviour: [],
      image: Buffer.alloc(1)
    },
    printing: {
      behaviour: []
    }
  };
  
export const serverUrl = "https://websiteonlytest.ru/datappapi/"